import React, { FC, useMemo } from 'react';

import { FormFiledProps } from './types';

import { StyledFormItem } from './styled';

const FormItem: FC<FormFiledProps> = ({ children, error = [], stretch, ...props }) => {
  const text = useMemo(() => error.shift(), [error]);

  return (
    <StyledFormItem validateStatus={text && 'error'} help={text} stretch={stretch} {...props}>
      {children}
    </StyledFormItem>
  );
};

FormItem.defaultProps = {
  labelCol: { span: 24 },
  wrapperCol: { span: 24 },
};

export default FormItem;
